import React from 'react'
import Spinner from '../Spinner/Spinner'
import { PieChart } from 'react-minimal-pie-chart'
import Chart from '../BarChart/Chart'
import OverviewTable from '../OverviewTable/OverviewTable'
import Tooltip from '../Tooltip/Tooltip'
import '../OverviewDashboard/OverviewDashboard.scss'

export default function DashboardTables(props) {

    const { apiLoaded, apiData, importData, importLoaded, exportData, exportLoaded, showCharts, isCommodity, tableData, tableDataLoaded } = props

    const TotalTEUs = Math.round(Number(apiData?.ExportTEUs))+ Math.round(Number(apiData?.ImportTEUs))    
    const TotalSTONS = Math.round(Number(apiData?.ExportSTONS)) + Math.round(Number(apiData?.ImportSTONS))

    return (
        <div className='dashboard-container'>
            {
                !isCommodity ?
                    (
                        <>
                            <div className='employment'>
                                <span className='icon' style={{ background: 'url(/wp-content/plugins/react-plugin/app/src/assets/images/icons/group.svg) no-repeat center/contain' }}></span>
                                <div>
                                    <div className='heading'>Economic impact on employment <Tooltip tooltipId="employment_tooltip" /></div>
                                    <div className='total'>Jobs: {apiLoaded ? Math.round(Number(apiData?.TotalEmployment).toFixed(0)).toLocaleString() : <Spinner />}</div>
                                </div>
                            </div>
                        </>
                    ) : null
            }
            <div className='dashboard-totals-section'>
                <div className='dashboard-table-container'>
                    <table className='overview-table  total'>
                        <tr className='table-title'>
                            <th colspan="2">IMPORT TOTAL</th>
                        </tr>
                        <tr className='table-data-rows'>
                            <td className='align-center'> <Tooltip tooltipId="TEUs_tooltip" /> TEUs:</td><td className='align-right'> {apiLoaded ? Math.round(Number(apiData?.ImportTEUs)).toLocaleString() : <Spinner />}</td>
                        </tr>
                        <tr className='table-data-rows'>
                            <td className='align-center'><Tooltip tooltipId="TONs_tooltip" /> Tons:</td><td className='align-right'> {apiLoaded ? Math.round(Number(apiData?.ImportSTONS)).toLocaleString() : <Spinner />}</td>
                        </tr>
                    </table>
                </div>
                <div className='dashboard-table-container'>
                    <table className='overview-table  total'>
                        <tr className='table-title'>
                            <th colspan="2">EXPORT TOTAL</th>
                        </tr>
                        <tr className='table-data-rows'>
                            <td className='align-center'><Tooltip tooltipId="TEUs_tooltip" /> TEUs:</td><td className='align-right'> {apiLoaded ? Math.round(Number(apiData?.ExportTEUs)).toLocaleString() : <Spinner />}</td>
                        </tr>
                        <tr className='table-data-rows'>
                            <td className='align-center'><Tooltip tooltipId="TONs_tooltip" /> Tons:</td><td className='align-right'> {apiLoaded ? Math.round(Number(apiData?.ExportSTONS)).toLocaleString() : <Spinner />}</td>
                        </tr>
                    </table>
                </div>
                <div className='dashboard-table-container'>
                    <table className='overview-table  total'>
                        <tr className='table-title'>
                            <th colspan="2">IMPORT + EXPORT TOTAL</th>
                        </tr>
                        <tr className='table-data-rows'>
                            <td className='align-center'><Tooltip tooltipId="TEUs_tooltip" />TEUs:</td><td className='align-right'> {apiLoaded ? TotalTEUs.toLocaleString() : <Spinner />}</td>
                        </tr>
                        <tr className='table-data-rows'>
                            <td className='align-center'><Tooltip tooltipId="TONs_tooltip" />Tons:</td><td> {apiLoaded ? TotalSTONS.toLocaleString() : <Spinner />}</td>
                        </tr>
                    </table>

                    <div className='table-pie'>
                        {
                            apiLoaded ?
                                <PieChart
                                    data={[
                                        { title: 'Import TONS', value: Math.round(Number(apiData?.ImportSTONS)), color: '#002A3A' },
                                        { title: 'Export TONS', value: Math.round(Number(apiData?.ExportSTONS)), color: '#04B2D9' }
                                    ]}
                                    animate={true}
                                    viewBoxSize={[100, 100]}
                                    label={({ dataEntry }) => (Math.round(dataEntry.percentage * 100 + Number.EPSILON) / 100).toFixed(0) + '%'}
                                    labelStyle={{ fontSize: '10px', fontWeight: 'bold', fill: '#ffffff' }}
                                    segmentsShift={(index) => (index === 0 ? 1 : 0.5)}
                                    radius={48}
                                /> : <Spinner />
                        }
                        <div className='chart-legend'>
                            <div><span className='color-import'></span><span>Import TONS</span></div>
                            <div><span className='color-export'></span><span>Export TONS</span></div>
                        </div>
                    </div>
                </div>
            </div>
            {
                showCharts ?
                    (
                        <>
                            <Chart data={importData}
                                barFill={'#00A79D'}
                                direction="IMPORTS"
                                loaded={importLoaded} />
                            <Chart data={exportData}
                                barFill={'#04B2D9'}
                                direction="EXPORTS"
                                loaded={exportLoaded} />
                        </>
                    ) : null
            }
            {
                isCommodity ?
                    (
                        <>
                            <OverviewTable
                                title="TOP 5 COUNTIES"
                                keyName="COUNTY"
                                data={tableData}
                                loaded={tableDataLoaded} />
                        </>
                    ) : null
            }
        </div>
    )
}